import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AUTH_PATHS } from '@/app/routes/paths';
import { useAuthStore } from '@/store/authStore';

export default function ProtectedRoute() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={AUTH_PATHS.login} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
